import RadioGroup from '@cred/react-editors/radio-group'
import { withFieldChangeEvent } from '@cred/react-analytics/hoc'

const RadioGroupWithAnalytics = withFieldChangeEvent(RadioGroup)

export default RadioGroupWithAnalytics
